module.exports = require("./../../_gen/starling/errors/AbstractMethodError");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/errors/AbstractMethodError.js
// module id = 176
// module chunks = 0